import { render, staticRenderFns } from "./BankAccountStatement.vue?vue&type=template&id=6ab0306e&scoped=true"
import script from "./BankAccountStatement.vue?vue&type=script&lang=js"
export * from "./BankAccountStatement.vue?vue&type=script&lang=js"
import style0 from "./BankAccountStatement.vue?vue&type=style&index=0&id=6ab0306e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab0306e",
  null
  
)

export default component.exports